import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import SubstateForm from './SubstateForm';

const SubstateActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const SubstateEdit = (props: any) => {
  return (
    <Edit actions={<SubstateActions {...props} />} {...props}>
      <SubstateForm />
    </Edit>
  );
};

export default SubstateEdit;
